import {Component, Input, OnInit, ViewChild} from "@angular/core";
import {OptionItem} from "../../classes/optionItem";
import {Option} from "../../classes/option";
import {StorageService} from "../../services/storage.service";
/**
 * Created by strunz on 05.05.2017.
 */

@Component({
    selector: 'treeView',
    templateUrl: './treeView.component.html',
    styleUrls: ['./treeView.component.css']
})
export class TreeViewComponent {
    @Input() optionItems: Array<OptionItem>;
    @Input() option: Option;

    constructor(private storageService: StorageService){};

    update(optionItem:OptionItem):void{
        if(!optionItem.disabled) {
            this.storageService.updateOptions();
        }else{
            optionItem.active = false;
        }
    }

}